function isAbsoluteURL(url: string): boolean {
  return new RegExp("^([a-z]+://|//)", "i").test(url);
}

export { isAbsoluteURL };
